var React = require('react');

function SingleNeutralCircle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"single-neutral-circle"),React.createElement("g",{"key":1},React.createElement("path",{"d":"M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12C23.993,5.376,18.624,0.007,12,0z M18.134,17.9 c-0.137,0.218-0.377,0.35-0.634,0.35h-11c-0.414,0-0.75-0.336-0.75-0.75c0-0.111,0.025-0.221,0.073-0.322 c1.615-3.411,5.689-4.868,9.101-3.253c1.428,0.676,2.577,1.825,3.253,3.253C18.288,17.41,18.271,17.683,18.134,17.9z M12,4.35 c2.043,0,3.7,1.657,3.7,3.7s-1.657,3.7-3.7,3.7s-3.7-1.657-3.7-3.7l0,0C8.3,6.007,9.957,4.35,12,4.35z","stroke":"none","fill":"currentColor","strokeWidth":"0","strokeLinecap":"round","strokeLinejoin":"round"}))]);
}

SingleNeutralCircle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = SingleNeutralCircle;

SingleNeutralCircle.default = SingleNeutralCircle;
